/* eslint-disable @typescript-eslint/no-explicit-any */
import { initApi } from '../../../api';
import { WIDGET_STATE } from '../../../common';
import { typedLocalStorage } from '../../../utils/typedLocalStorage';
import { SocketService } from './socketService';
import { widgetSettingsMapper } from './widgetSettingsMapper';
export const initHandleFrameMessages = ({ setWidgetSettings, setApi, setCurrentWidgetState, setSocketService, setNewUserData, setCustomSettings, }) => {
    let socketService;
    return (msg) => {
        const { serverParams, visualParams, userData, user, isDisabledNameAndEmail, customFields } = msg.data;
        if (isDisabledNameAndEmail !== undefined) {
            setCustomSettings((prev) => (Object.assign(Object.assign({}, prev), { isDisabledNameAndEmail })));
        }
        if (customFields !== undefined) {
            setCustomSettings((prev) => (Object.assign(Object.assign({}, prev), { customFields })));
        }
        if (visualParams) {
            const widgetSettings = visualParams && widgetSettingsMapper.mapFrom(visualParams.params);
            const clientId = serverParams === null || serverParams === void 0 ? void 0 : serverParams.initParamData.clientId;
            clientId && setApi(initApi(clientId));
            widgetSettings &&
                setWidgetSettings(Object.assign(Object.assign({}, widgetSettings), { language: serverParams === null || serverParams === void 0 ? void 0 : serverParams.user.language, application: (serverParams === null || serverParams === void 0 ? void 0 : serverParams.host.includes('happydesk')) ? 'Happydesk' : 'Pulsedesk', host: serverParams === null || serverParams === void 0 ? void 0 : serverParams.host }));
        }
        if (visualParams === null || visualParams === void 0 ? void 0 : visualParams.params.blocks.length) {
            const { blocks } = visualParams.params;
            if (blocks.includes('knowledge'))
                setCurrentWidgetState(WIDGET_STATE.KNOWLEDGE_BASE);
            else
                setCurrentWidgetState(WIDGET_STATE.WRITE_TO_US_FORM);
        }
        if (serverParams && (visualParams === null || visualParams === void 0 ? void 0 : visualParams.params.blocks.includes('chat'))) {
            socketService = new SocketService(serverParams);
            setSocketService(socketService);
        }
        if (userData && userData.type === 'userData') {
            const userAccount = { email: userData.email, name: userData.name };
            typedLocalStorage.setItem('userData', JSON.stringify(userAccount));
            socketService && (socketService.joinResponseData = null);
            setNewUserData(JSON.stringify(userAccount));
        }
        if (user === null || user === void 0 ? void 0 : user.page_url) {
            typedLocalStorage.setItem('refererHost', user.page_url);
        }
    };
};
